import React, {useEffect, useState} from "react";
import keycloak from "../utils/keycloak";
import {useSetRecoilState} from "recoil";
import {authState} from "../states/auth-state/auth-atoms";
import {ThreeDots} from "react-loader-spinner";
import {Providers} from "../providers";
import {WatchInfo} from "../states/plan-state/plan-atoms";

interface KeycloakProviderProps {
  children: React.ReactNode;
}

const KeycloakProvider: React.FC<KeycloakProviderProps> = ({ children }) => {
  const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const setAuthState = useSetRecoilState(authState);

  useEffect(() => {
    setPostData();
    const initKeycloak = async () => {
      try {
        await keycloak.init({ onLoad: "check-sso" });
        if (keycloak.authenticated) {
          setAuthenticated(true);
          localStorage.setItem("token", keycloak?.token || "");
          localStorage.setItem("name", keycloak?.tokenParsed?.name || "");
          localStorage.setItem("email", keycloak?.tokenParsed['email'] || "");
          setAuthState({
            token: keycloak.token || null,
            refreshToken: keycloak.refreshToken || null,
            tokenParsed: keycloak.tokenParsed || null,
          });
        } else {
          keycloak.login({idpHint: 'okta'});
        }
      } catch (error) {
        console.error("Keycloak initialization failed:", error);
      } finally {
        setLoading(false);
      }
    };

    initKeycloak();
  }, [setAuthState]);

  const setPostData = () => {
    const params = new URLSearchParams(window.location.search);
    localStorage.setItem("eid", params?.get("eid") || "");
    localStorage.setItem(
        "primaryDeviceIccid",
        params?.get("primaryDeviceIccid") || "",
    );
    const watchInfo: WatchInfo = {
      carrierPostData: params?.get("carrierPostData") || "",
      eid: params?.get("eid") || "",
      iccid: params?.get("iccids") || "",
      displayName: decodeURIComponent(params?.get("displayName") || "") || "",
      deviceImei: params?.get("deviceImei") || "",
      deviceMeid: params?.get("deviceMeid") || "",
      deviceType: params?.get("deviceType") || "",
      primaryDeviceIccid: params?.get("primaryDeviceIccid") || "",
    };
    localStorage.setItem("watchInfo", JSON.stringify(watchInfo) || "");
    localStorage.setItem('deviceImei', params?.get("deviceImei") || "");
  };

  if (loading) {
    return (
        <ThreeDots
            visible={true}
            height="80"
            width="80"
            color="#FFD200"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperClass="full-layout"
        />
    );
  }

  if (!authenticated) {
    return (
        <ThreeDots
            visible={true}
            height="80"
            width="80"
            color="#FFD200"
            radius="9"
            ariaLabel="three-dots-loading"
            wrapperClass="full-layout"
        />
    );
  }

  return <Providers>{children}</Providers>;
};

export default KeycloakProvider;
